import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import {validateForm, blurValidations} from '../Common/formValidator';
import ModalBox from '../Common/Modals/ModalBox';

import { API } from '../../ws/constants';

class AddEditSupplier extends Component {
    constructor(props) {
        super(props);

        this.state = {
            supplierId:this.props.props.match.params.id
            ,openModal:false
            ,showPicker:false
            ,returnTitle: "Erro"
            ,returnText: "Ocorreu algum erro"
            ,editable: (this.props.isAdmin || this.props.loginData.profile.Suppliers.permission === 1)
            ,somethingWasEdited: false
            ,loggedIn:this.props.isLoggedIn
            ,loading:false
            ,addEditTitle:"Novo Fornecedor"
            ,name:""
            ,shortname:""
            ,representative:""
            ,cellphone:""
            ,phone:""
            ,email:""
            ,address:""
            ,description:""
            ,notes:""
            ,isActive:1
        };
    }
    componentDidMount() {
        const { supplierId } = this.state;
        if(supplierId > 0){            
            fetch(API + 'getsuppliers&getbyid=' + supplierId)
            .then(response => response.json())
            .then(result => {
                const supplierData = result.data;

                if(result === null || result.shortmsg === "NOK"){
                    this.props.props.history.push('/Suppliers');
                    return;
                }
                
                this.setState({ 
                    addEditTitle: supplierData.Name
                    ,name: supplierData.Name
                    ,shortname: supplierData.Shortname
                    ,representative: supplierData.Representative
                    ,cellphone: supplierData.Cellphone
                    ,phone: supplierData.Phone
                    ,email: supplierData.Email
                    ,address: supplierData.Address
                    ,description: supplierData.Description
                    ,notes: supplierData.Notes
                    ,isActive: supplierData.IsActive
                });
            });
        }
        blurValidations($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false });
    }

    handleTitleChange = (e) => {this.setState({ [e.target.id]: e.target.value, addEditTitle: e.target.value, somethingWasEdited:true });}
    handleSelectChange = (e) => this.setState({ [e.target.name]: e.target.value, somethingWasEdited:true });
    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value, somethingWasEdited:true });
    handleToggle = (e, value) => this.setState({ [e.target.id]: value ? "1" : "0", somethingWasEdited:true });
    handleColorChange = (value) => this.setState({color: value.hex, somethingWasEdited:true});

    handleSave = (e) => {
        e.preventDefault();

        if(!this.state.somethingWasEdited)
            return;

        if(validateForm($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false })){
            let DEFAULT_QUERY = "savesupplier&supplierid=" + this.state.supplierId + "&name=" + this.state.name.trim() + "&shortname=" + this.state.shortname.trim()
                                + "&representative=" + this.state.representative.trim() + "&cellphone=" + this.state.cellphone.trim() + "&phone=" + this.state.phone.trim()
                                + "&email=" + this.state.email.trim() + "&address=" + this.state.address.trim() + "&description=" + this.state.description.trim() 
                                + "&notes=" + this.state.notes.trim() + "&isactive=" + this.state.isActive
                                + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name;

            this.setState({loading:true});
            fetch(API + DEFAULT_QUERY)
            .then(response => response.json())
            .then(result => {this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, loading:false })});
        }
    }

    handleDelete = (e) => {
        if(window.confirm("Tem a certeza que quer apagar este fornecedor?")){
            this.setState({loading:true});
            fetch(API + 'deletesupplier&supplierid=' + this.state.supplierId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, loading:false });
            });
        }
    }

    showPicker = () => {
        this.setState({showPicker:true});
    }

    hidePicker = () => {
        this.setState({showPicker:false});
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
        this.props.props.history.push('/Suppliers');
    }

    render() {
        const { isAdmin, loginData } = this.props;
        const { editable } = this.state;

        const addEditTitle = this.state.addEditTitle
              , loadingClass = this.state.loading ? " ajaxLoading" : "";

        return (
            <form id="addEditSupplierPage" ref="editForm" onSubmit={this.handleSave} className={"form addEditPage" + loadingClass}>
                <div className="row">
                    <div className="col-12">
                        <h1><i className="fa fa-dolly"></i> {addEditTitle}                
                        { (isAdmin || loginData.profile.Suppliers.isActive) && 
                            <span className="float-right">
                            <FormControlLabel
                                label="Ativo"
                                control={
                                    <Switch
                                        id="isActive"
                                        checked={!!+this.state.isActive}
                                        disabled={!(isAdmin || (loginData.profile.Suppliers.isActive.permission === 1 && editable))}
                                        onChange={this.handleToggle}
                                        color="primary"/>
                                }/>
                            </span>
                        }
                        </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-6 fieldHolder required">
                        <TextField fullWidth={true}
                                    id="name"
                                    value={this.state.name}
                                    onChange={this.handleTitleChange}
                                    label="Nome"
                                    placeholder="Introduza o nome"
                                    disabled={!editable}
                                    data-empty-error-message="Este campo não pode estar vazio" />
                    </div>
                    <div className="col-12 col-md-6 fieldHolder">
                        <TextField fullWidth={true}
                                    id="cellphone"
                                    value={this.state.cellphone}
                                    onChange={this.handleFieldChange}
                                    disabled={!editable}
                                    label="Telemóvel"
                                    placeholder="Introduza o Telemóvel" />
                    </div>
                    <div className="col-12 col-md-6 fieldHolder required">
                        <TextField fullWidth={true}
                                    id="shortname"
                                    value={this.state.shortname}
                                    onChange={this.handleFieldChange}
                                    disabled={!editable}
                                    label="Abreviatura"
                                    placeholder="Introduza a abreviatura"
                                    data-empty-error-message="Este campo não pode estar vazio" />
                    </div>
                    <div className="col-12 col-md-6 fieldHolder">
                        <TextField fullWidth={true}
                                    id="phone"
                                    value={this.state.phone}
                                    onChange={this.handleFieldChange}
                                    disabled={!editable}
                                    label="Telefone"
                                    placeholder="Introduza o Telefone" />
                    </div>
                    <div className="col-12 col-md-6 fieldHolder">
                        <TextField fullWidth={true}
                                    id="representative"
                                    value={this.state.representative}
                                    onChange={this.handleFieldChange}
                                    disabled={!editable}
                                    label="Representante"
                                    placeholder="Introduza o nome do Representante" />
                    </div>
                    <div className="col-12 col-md-6 fieldHolder validEmail">
                        <TextField fullWidth={true}
                                    id="email"
                                    value={this.state.email}
                                    onChange={this.handleFieldChange}
                                    disabled={!editable}
                                    label="Email"
                                    placeholder="Introduza o email"
                                    data-email-error-message="Este email não está correto." />
                    </div>
                    <div className="col-12 col-md-6 fieldHolder">
                        <TextField fullWidth={true}
                                    id="description"
                                    value={this.state.description}
                                    onChange={this.handleFieldChange}
                                    disabled={!editable}
                                    multiline={true}
                                    rows={4}
                                    label="Descrição" />
                    </div>
                    <div className="col-12 col-md-6 fieldHolder">
                        <TextField fullWidth={true}
                                    id="address"
                                    value={this.state.address}
                                    onChange={this.handleFieldChange}
                                    disabled={!editable}
                                    multiline={true}
                                    rows={4}
                                    label="Morada"
                                    placeholder="Introduza a morada" />
                    </div>
                    <div className="col-12 col-md-6 fieldHolder">
                        <TextField fullWidth={true}
                                    id="notes"
                                    value={this.state.notes}
                                    onChange={this.handleFieldChange}
                                    disabled={!editable}
                                    multiline={true}
                                    rows={4}
                                    label="Observações" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 buttonsHolder">
                        <Button onClick={this.props.props.history.goBack} variant="contained" className="defaultButton">Voltar</Button>
                        { (isAdmin || loginData.profile.Suppliers.DEL) && this.state.userId !== "New" && <Button onClick={this.handleDelete} className="button button-danger" variant="contained">Apagar Fornecedor</Button>}
                        { editable && <Button type="submit" className="button float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </form>
        );
    }
}

export default AddEditSupplier;
